import { useTranslation } from "react-i18next";

function OrderStatus({ status }: { status: number }) {
  const { t } = useTranslation();

  return (
    <>
      {(() => {
        switch (status) {
          case 3:
          case 5:
            return <p className="text-success">{t("Processed")}</p>;
          case 6:
          case 7:
            return <p className="text-orange-600">{t("Canceled")}</p>;
          case 8:
            return <p className="text-white">{t("Under review")}</p>;
          case 9:
            return <p className="text-primary">{t("Processing")}</p>;
          case 10:
            return (
              <p className="text-orange-600">{t("Revision in Progress")}</p>
            );
          case 11:
            return <p className="text-red-600">{t("Rejected")}</p>;
          case 12:
          case 13:
            return <p className="text-success">{t("Completed")}</p>;
          default:
            return <p className="text-careful">{t("In processing")}</p>;
        }
      })()}
    </>
  );
}

export default OrderStatus;
